import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "react-router-dom";

interface ConsentCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  context?: "signup" | "data-upload";
}

export const ConsentCheckbox = ({ 
  checked, 
  onCheckedChange, 
  context = "signup" 
}: ConsentCheckboxProps) => {
  const getConsentText = () => {
    switch (context) {
      case "data-upload":
        return "I consent to the processing of my uploaded data according to the";
      case "signup":
      default:
        return "I agree to the";
    }
  };

  return (
    <div className="flex items-start space-x-2">
      <Checkbox
        id="consent-checkbox"
        checked={checked}
        onCheckedChange={onCheckedChange}
        className="mt-0.5"
      />
      <label
        htmlFor="consent-checkbox"
        className="text-sm text-muted-foreground leading-relaxed cursor-pointer"
      >
        {getConsentText()}{" "}
        <Link 
          to="/privacy-policy" 
          className="text-primary hover:underline"
          target="_blank"
        >
          Privacy Policy
        </Link>
        {" "}and{" "}
        <Link 
          to="/terms-of-use" 
          className="text-primary hover:underline"
          target="_blank"
        >
          Terms of Use
        </Link>
        {context === "data-upload" && (
          <span className="block mt-1 text-xs">
            By uploading data, you confirm you have the legal right to process this information.
          </span>
        )}
      </label>
    </div>
  );
};